import { TPopupProps } from '@@types/popup';
import { analyticsCheckout, closeAnalyticsCheckout } from '../../utils/web-analytics';
import {
  Step,
  StepIndicator,
  StepNumber,
  Stack,
  DrawerBody,
  DrawerHeader,
  DrawerContent,
  StepIcon,
  Stepper,
  StepSeparator,
  StepStatus,
  useSteps,
} from '@chakra-ui/react';
import Prev from '@components/prev';
import Content from '@components/content';
import OrderContainer from '@containers/checkout/order-process';
import useOrder from '@hooks/useOrder';
import usePopup from '@hooks/usePopup';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type TCartFunnul = 'cart' | 'payment' | 'done' | 'auth';
const steps = [{ title: 'Menu' }, { title: 'Cart' }, { title: 'Checkout' }];
export default function CartContainer({
  props,
}: TPopupProps<{ step: TCartFunnul | undefined }>) {
  const [funnel, setFunnel] = useState<TCartFunnul>(props.step || 'cart');
  useEffect(() => { analyticsCheckout(funnel); }, [funnel]);
  useEffect(() => () => closeAnalyticsCheckout(), []);
  const { initOrderOption } = useOrder();
  const { closePopup } = usePopup();
  const { t } = useTranslation('store');
  const { activeStep, goToNext, goToPrevious } = useSteps({
    index: 1,
    count: steps.length,
  });

  const handlePrev = () => {
    if (funnel === 'cart') {
      closePopup('cart');
      return;
    }
    goToPrevious();
    setFunnel('cart');
  };
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
      initOrderOption();
    };
  }, []);
  return (
    <>
      <DrawerContent
        ref={(node) => {
          if (node) {
            node.style.height = window.innerHeight + 'px';
          }
        }}
        maxHeight="100vh"
      >
        <DrawerHeader
          fontSize="md"
          position="relative"
          minH="60px"
          display="flex"
          alignItems="center"
        >
          <Prev onClick={handlePrev}></Prev>
          <span className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            {t(steps[activeStep].title.toLocaleLowerCase())}
          </span>
          <Stack className="absolute bottom-[-12px] left-0 w-full z-10">
            <Content className="w-full">
              <Stepper size="sm" colorScheme="red" index={activeStep} gap="0">
                {steps.map((step, index) => (
                  <Step key={index} style={{ gap: '0' }}>
                    <StepIndicator gap="0">
                      <StepStatus
                        complete={<StepIcon />}
                        incomplete={<StepNumber />}
                        active={<StepNumber />}
                      />
                    </StepIndicator>
                    <StepSeparator
                      style={{ margin: '0', width: '100%', gap: '0' }}
                    />
                  </Step>
                ))}
              </Stepper>
            </Content>
          </Stack>
        </DrawerHeader>
        <DrawerBody px="0">
          <OrderContainer
            funnel={funnel}
            setFunnel={(step: TCartFunnul) => setFunnel(step)}
            goToNext={goToNext}
          />
        </DrawerBody>
      </DrawerContent>
    </>
  );
}
